<template>
    <div class="align-center">
        <div class="d-flex justify-center">
            <v-avatar class="d-inline-block" size="128">
                <v-icon dark size="96" color="ddgrey">mdi-account-circle</v-icon>
            </v-avatar>
            <div class="text-left">
                <span class="text-h3 d-block">{{ $t('components.ProfileHeader.GrettingText', { name: user.name }) }}</span>
                <span class="d-block ddgrey--text mt-2">
                    <v-chip v-if="user.isAdmin" small color="green" class="mr-2 px-2">Admin</v-chip>
                    {{ user.email }}
                </span>
            </div>
        </div>
        <v-divider class="my-5 pb-5" style="width: 80%; margin-left: 10%;"/>
        <StyleChanger/>
    </div>
</template>
<script>
import StyleChanger from '@/components/profile/StyleChanger';

/**
 * ProfileHeader component its a expanded version of UserAccount component to 
 * use it as page header.
 */
export default {
    name: 'ProfileHeader',
    props: {
        user: {
            type: Object,
            required: true,
            default: () => ({ 
                name: null,
                email: null,
                isAdmin: false
            })
        }
    },
    components: { StyleChanger }
}
</script>